import { BrowsePrimitivesLayout } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.primitives";
import { BrowsePrimitivesListSkeleton } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._components.loading-skeletons";
import { BrowsePrimitivesCompoundsSkeleton } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.primitives._components.compounds-skeleton";
import type { SuspenseFallbackProps } from "@-/com.npmjs.expo-router";

const compoundsRoute = /\/compounds\.[cm]?[jt]sx?$/;

export function SuspenseFallback({ route }: SuspenseFallbackProps) {
  // Use this boundary's route identity, never the global pathname of another focused tab.
  return compoundsRoute.test(route) ? (
    <BrowsePrimitivesCompoundsSkeleton />
  ) : (
    <BrowsePrimitivesListSkeleton />
  );
}

export default function BrowsePrimitivesLayoutRoute() {
  return <BrowsePrimitivesLayout />;
}
